var UF_WL_UNAV = "Uitverkocht";
!function (i, t) {
    var META_KEY = "user_wishlist_meta";
    function ufReadWishlistIds() {
        try {
            var r = localStorage.getItem("user_wishlist");
            if (!r) return [];
            var p = JSON.parse(r);
            if (!Array.isArray(p)) return [];
            var o = [];
            p.forEach(function (v) {
                var s = String(v != null ? v : "").trim();
                if (s) o.push(s);
            });
            return o;
        } catch (e) {
            return [];
        }
    }
    function ufReadWishlistMeta() {
        try {
            var o = JSON.parse(localStorage.getItem(META_KEY) || "{}");
            return o && typeof o === "object" ? o : {};
        } catch (e) {
            return {};
        }
    }
    function ufWriteWishlistMeta(m) {
        try {
            localStorage.setItem(META_KEY, JSON.stringify(m));
        } catch (e) {}
    }
    function ufWishlistMetaSet(id, handle) {
        if (!id || !handle) return;
        var m = ufReadWishlistMeta();
        m[id] = handle;
        ufWriteWishlistMeta(m);
    }
    function ufPruneWishlistMetaToIds(ids) {
        var m = ufReadWishlistMeta(),
            next = {};
        ids.forEach(function (id) {
            if (m[id]) next[id] = m[id];
        });
        ufWriteWishlistMeta(next);
    }
    function ufSaveWishlistIds(ids) {
        if (window.ufWishlistPersistIds) {
            l = window.ufWishlistPersistIds(ids);
            ufPruneWishlistMetaToIds(l);
            return l;
        }
        try {
            l = ids;
            localStorage.setItem("user_wishlist", JSON.stringify(ids));
            ufPruneWishlistMetaToIds(ids);
        } catch (e) {}
        return ids;
    }
    function ufEscHtml(s) {
        return String(s || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }
    function ufEscAttr(s) {
        return String(s || "")
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }
    /** UF-03: accessoire/plint → per stuk; trap → geen label; anders per m² */
    function ufWlPriceUnitLabel(tags) {
        var list = tags || [];
        for (var i = 0; i < list.length; i++) {
            var t = String(list[i] || "")
                .trim()
                .toLowerCase();
            if (t === "segment: traprenovatie" || t === "traprenovatie") return "";
            if (
                t === "segment: accessoire" ||
                t === "segment: plint" ||
                t === "segment: plinten" ||
                t === "accessoires" ||
                t === "accessoire"
            ) {
                return "per stuk";
            }
        }
        return "per m²";
    }
    function ufPriceToCents(v) {
        if (v == null || v === "") return 0;
        if (typeof v === "number") {
            if (v >= 1e3 && Number.isInteger(v)) return v;
            return Math.round(v * 100);
        }
        var n = parseFloat(String(v).replace(/[^\d.,-]/g, "").replace(",", "."));
        return isNaN(n) ? 0 : Math.round(n * 100);
    }
    function ufFmtMoney(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === "function" && window.money_format) {
            return Shopify.formatMoney(cents, window.money_format);
        }
        return (cents / 100).toFixed(2);
    }
    function ufImg600(src) {
        if (!src) return "";
        var u = String(src).indexOf("//") === 0 ? "https:" + src : String(src);
        return u.replace(/(\.(?:jpg|jpeg|gif|png|webp))(\?.*)?$/i, "_600x$1$2");
    }
    function ufImg275(src) {
        if (!src) return "";
        var u = String(src).indexOf("//") === 0 ? "https:" + src : String(src);
        return u.replace(/(\.(?:jpg|jpeg|gif|png|webp))(\?.*)?$/i, "_275x$1$2");
    }
    function ufProductImages600(p) {
        var urls = [];
        if (p.images && p.images.length) {
            p.images.forEach(function (im) {
                var src = im.src || im;
                var u = ufImg600(src);
                if (u) urls.push(u);
            });
        } else if (p.featured_image) {
            var u2 = ufImg600(p.featured_image);
            if (u2) urls.push(u2);
        }
        return urls.join("||");
    }
    function ufTagsJoin(tags) {
        if (!tags || !tags.length) return "";
        return tags
            .map(function (x) {
                return String(x || "");
            })
            .join("||");
    }
    function ufWlIsMerkColonTag(tag) {
        var raw = String(tag || "");
        var c = raw.indexOf(":");
        if (c === -1) return false;
        return raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, " ") === "merk";
    }
    function ufWlMerkLabelFromTag(tag) {
        var raw = String(tag || "");
        var c = raw.indexOf(":");
        return c === -1 ? raw.trim() : raw.slice(c + 1).trim();
    }
    function ufWlIsPlintenProfielProduct(tileTags, title, productType) {
        var t = String(title || "").toLowerCase();
        var pt = String(productType || "").toLowerCase();
        if (t.indexOf("trapprofiel") !== -1) return true;
        if (pt.indexOf("plint") !== -1 || pt.indexOf("profiel") !== -1) return true;
        for (var i = 0; i < (tileTags || []).length; i++) {
            var raw = String(tileTags[i] || "").trim();
            var tl = raw.toLowerCase();
            if (tl === "segment: plint" || tl === "segment: plinten" || tl === "plinten" || tl === "plint") return true;
            var c = raw.indexOf(":");
            if (c === -1) continue;
            var head = raw.slice(0, c).trim().toLowerCase().replace(/\s+/g, " ");
            var val = raw.slice(c + 1).trim().toLowerCase();
            if (head === "soort filter" || head === "productgroep" || head === "assortiment") {
                if (val.indexOf("plint") !== -1 || val.indexOf("profiel") !== -1) return true;
            }
        }
        return false;
    }
    function ufWlMerkDisplayFromProduct(tileTags, title, productType) {
        if (ufWlIsPlintenProfielProduct(tileTags, title, productType)) return "";
        var knownTags = {
            "merk: ambiant": "Ambiant",
            "merk: belakos": "Belakos",
            "merk: tarkett": "Tarkett"
        };
        var j;
        for (j = 0; j < (tileTags || []).length; j++) {
            var raw = String(tileTags[j] || "").trim().toLowerCase();
            if (knownTags[raw]) return knownTags[raw];
        }
        for (j = 0; j < (tileTags || []).length; j++) {
            var raw2 = tileTags[j];
            if (!ufWlIsMerkColonTag(raw2)) continue;
            var lk = ufWlMerkLabelFromTag(raw2).toLowerCase();
            if (lk === "ambiant") return "Ambiant";
            if (lk === "belakos") return "Belakos";
            if (lk === "tarkett") return "Tarkett";
        }
        var tl = String(title || "").toLowerCase();
        if (tl.indexOf("tarkett") !== -1) return "Tarkett";
        if (tl.indexOf("ambiant") !== -1) return "Ambiant";
        if (tl.indexOf("belakos") !== -1) return "Belakos";
        return "";
    }
    function ufWlIsTarkettProduct(tags) {
        var arr = tags;
        if (arr == null) return false;
        if (typeof arr === "string") {
            arr = arr.length ? arr.split(/\|\|/) : [];
        }
        if (!Array.isArray(arr)) return false;
        for (var i = 0; i < arr.length; i++) {
            if (String(arr[i]).trim().toLowerCase() === "merk: tarkett") return true;
        }
        return false;
    }
    function ufVariantForCard(p) {
        var vs = p.variants || [];
        if (!vs.length) return {};
        var i,
            v;
        for (i = 0; i < vs.length; i++) {
            v = vs[i];
            if (v.available !== false && String(v.available) !== "false") return v;
        }
        return vs[0];
    }
    function ufVariantCompareRaw(v) {
        if (!v) return null;
        var c = v.compare_at_price != null ? v.compare_at_price : v.compareAtPrice;
        return c;
    }
    function ufBuildFetchedWishlistTile(p, itemClasses, transparentSrc) {
        var v = ufVariantForCard(p);
        var id = String(p.id);
        var handle = String(p.handle || "");
        var href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "products/" + encodeURIComponent(handle);
        var m2pp =
            typeof window.ufParseM2PerPackFromProduct === "function"
                ? window.ufParseM2PerPackFromProduct(p)
                : 1;
        if (!m2pp || isNaN(m2pp) || m2pp <= 0) m2pp = 1;
        var priceC = Math.round(ufPriceToCents(v.price) / m2pp);
        var cmpRaw = ufPriceToCents(ufVariantCompareRaw(v));
        var cmpC = cmpRaw > 0 ? Math.round(cmpRaw / m2pp) : 0;
        var ufR5 =
            typeof window.ufRoundPerM2DisplayCents === "function"
                ? window.ufRoundPerM2DisplayCents
                : function (x) {
                      var n = Math.round(Number(x));
                      if (!isFinite(n) || n < 0) n = 0;
                      return Math.round(n / 5) * 5;
                  };
        priceC = ufR5(priceC);
        if (cmpC > 0) cmpC = ufR5(cmpC);
        var avail = v.available !== false && String(v.available) !== "false";
        var tagsStr = ufTagsJoin(p.tags);
        var imgsPipe = ufProductImages600(p);
        var imgUrls = imgsPipe.split("||").filter(Boolean);
        var isTarkett = ufWlIsTarkettProduct(p.tags);
        var hasSecond = imgUrls.length > 1;
        var mainSrc = imgUrls[0] || "";
        var hoverSrc = "";
        if (hasSecond) {
            if (isTarkett) {
                mainSrc = imgUrls[imgUrls.length - 1] || mainSrc;
                var firstIm = p.images && p.images.length ? p.images[0] : null;
                hoverSrc = firstIm ? ufImg275(firstIm.src || firstIm) : "";
            } else {
                var lastIm = p.images && p.images.length ? p.images[p.images.length - 1] : null;
                hoverSrc = lastIm ? ufImg275(lastIm.src || lastIm) : "";
            }
        }
        var titleH = ufEscHtml(p.title);
        var mainImgIdx = isTarkett && p.images && p.images.length > 1 ? p.images.length - 1 : 0;
        var imgAlt = ufEscAttr((p.images && p.images[mainImgIdx] && p.images[mainImgIdx].alt) || p.title || "");
        var navHtml = "";
        if (imgUrls.length > 1) {
            navHtml =
                '<button type="button" class="uf-card-nav uf-card-nav--prev" aria-label="Vorige afbeelding">&#10095;</button>' +
                '<button type="button" class="uf-card-nav uf-card-nav--next" aria-label="Volgende afbeelding">&#10094;</button>';
        }
        var priceInner = "";
        if (avail) {
            priceInner = '<div class="uf-collection-card-meta__price-row">';
            if (cmpC > priceC && cmpC > 0) {
                priceInner += '<span class="uf-collection-card-meta__compare money">' + ufEscHtml(ufFmtMoney(cmpC)) + "</span>";
            }
            priceInner +=
                '<span class="uf-collection-card-meta__current money">' +
                ufEscHtml(ufFmtMoney(priceC)) +
                "</span>";
            var unitLbl = ufWlPriceUnitLabel(p.tags);
            if (unitLbl) {
                priceInner += '<span class="uf-collection-card-meta__unit">' + unitLbl + "</span>";
            }
            priceInner += "</div>";
        } else {
            priceInner = '<span class="uf-collection-card-meta__unavailable">' + ufEscHtml(UF_WL_UNAV) + "</span>";
        }
        var imgBlock =
            '<img src="' +
            ufEscAttr(mainSrc) +
            '" data-primary-src="' +
            ufEscAttr(mainSrc) +
            '" alt="' +
            imgAlt +
            '" loading="lazy" decoding="async" class="' +
            (hasSecond ? "first--image" : "") +
            '" />';
        if (hasSecond && hoverSrc) {
            imgBlock +=
                '<img src="' +
                ufEscAttr(transparentSrc) +
                '" data-src="' +
                ufEscAttr(hoverSrc) +
                '" data-size="auto" loading="lazy" decoding="async" class="lazyload second--image" alt="' +
                titleH +
                '" height="" />';
        }
        var merkLabel = ufWlMerkDisplayFromProduct(p.tags, p.title, p.product_type);
        var merkHtml = merkLabel ? '<span class="uf-home-product__merk">' + ufEscHtml(merkLabel) + "</span>" : "";
        var wlSvg =
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.15 16.927" fill="currentColor" aria-hidden="true"><path d="M13.67 0a4.85 4.85 0 0 0-4.1 2.23A4.86 4.86 0 0 0 5.47 0 5.53 5.53 0 0 0 0 5.67c0 2.42 1.2 4.8 3.53 7.1a24.9 24.9 0 0 0 5.82 4.1.5.5 0 0 0 .46 0 24.94 24.94 0 0 0 5.82-4.1c2.34-2.3 3.53-4.68 3.53-7.1A5.53 5.53 0 0 0 13.67 0z"/></svg>';
        var wlBtn =
            '<a class="action--wishlist tile-actions--btn flex wishlist-btn is-active" href="javascript:;" data-toggle="tooltip" data-placement="bottom" data-product-id="' +
            ufEscAttr(id) +
            '" data-product-handle="' +
            ufEscAttr(handle) +
            '" data-original-title="Remove from Wishlist"><span>' +
            wlSvg +
            "</span></a>";
        return (
            '<div data-id="' +
            ufEscAttr(id) +
            '" class="' +
            ufEscAttr(itemClasses) +
            '" data-product-price="' +
            String(priceC) +
            '" data-product-tags="' +
            ufEscAttr(tagsStr) +
            '" data-product-images="' +
            ufEscAttr(imgsPipe) +
            '" data-product-id="' +
            ufEscAttr(id) +
            '" id="pro_' +
            ufEscAttr(id) +
            '" data-product-handle="' +
            ufEscAttr(handle) +
            '">' +
            '<div class="grid_collection_box uf-collection-tile--meta-below" data-product-options-wrapper>' +
            '<div class="grid__product-image text-center">' +
            '<a href="' +
            ufEscAttr(href) +
            '" class="grid__image">' +
            imgBlock +
            merkHtml +
            "</a>" +
            navHtml +
            "</div>" +
            '<a href="' +
            ufEscAttr(href) +
            '" class="uf-collection-card-meta">' +
            '<h4 class="uf-collection-card-meta__title">' +
            titleH +
            "</h4>" +
            '<div class="uf-collection-card-meta__price">' +
            priceInner +
            "</div></a>" +
            '<div class="grid__product-content text-center category_detail">' +
            '<div class="product-tile--tile-actions flex pro_' +
            ufEscAttr(id) +
            '">' +
            wlBtn +
            '<div class="wishlist_mobile"><div class="wishlist_text">Added to wishlist</div></div></div></div></div></div>'
        );
    }
    function ufFetchMissingWishlistTiles(l, afterCount) {
        var grid = document.querySelector(".wishlist-grid");
        if (!grid) return Promise.resolve(afterCount);
        var itemClasses =
            grid.getAttribute("data-uf-wishlist-item-classes") ||
            "grid__item grid_less_padding large--one-third medium--one-half margin--bottom-15 small--one-half custom--width-one-half product-tile-container wishlist-tile-container";
        var transparentSrc = grid.getAttribute("data-uf-transparent") || "";
        var meta = ufReadWishlistMeta();
        var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
        var missing = [];
        l.forEach(function (id) {
            if (!grid.querySelector('.wishlist-tile-container[data-product-id="' + id.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"]')) {
                missing.push(id);
            }
        });
        if (!missing.length) return Promise.resolve(afterCount);
        var fetches = missing.map(function (id) {
            var h = meta[id];
            if (!h) return Promise.resolve(null);
            return fetch(root + "products/" + encodeURIComponent(h) + ".js")
                .then(function (r) {
                    return r.ok ? r.json() : null;
                })
                .catch(function () {
                    return null;
                });
        });
        return Promise.all(fetches).then(function (products) {
            var added = 0;
            products.forEach(function (p) {
                if (!p || !p.id) return;
                var pid = String(p.id);
                if (l.indexOf(pid) === -1) return;
                if (grid.querySelector('.wishlist-tile-container[data-product-id="' + pid.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"]')) return;
                var html = ufBuildFetchedWishlistTile(p, itemClasses, transparentSrc);
                var wrap = document.createElement("div");
                wrap.innerHTML = html;
                var el = wrap.firstElementChild;
                if (!el) return;
                var emptyEl = grid.querySelector(".wishlist-grid--empty-list");
                if (emptyEl) grid.insertBefore(el, emptyEl);
                else grid.appendChild(el);
                added++;
            });
            try {
                var ls = window.lazySizes;
                var unveil =
                    ls &&
                    (typeof ls.unveil === "function"
                        ? ls.unveil
                        : ls.loader && typeof ls.loader.unveil === "function"
                          ? ls.loader.unveil.bind(ls.loader)
                          : null);
                if (unveil) {
                    grid.querySelectorAll(".lazyload").forEach(function (node) {
                        try {
                            unveil(node);
                        } catch (eLz) {}
                    });
                }
            } catch (eLs) {}
            return afterCount + added;
        });
    }
    var l = ufReadWishlistIds();
    var o = function () {
        if (!/\/pages\/(wishlist|wish-list)\b/.test(window.location.href)) return;
        l = ufReadWishlistIds();
        var e = t(".wishlist-tile-container"),
            a = e.length;
        e.each(function () {
            var id = String(t(this).attr("data-product-id") || ""),
                h = String(t(this).attr("data-product-handle") || "").trim();
            if (l.indexOf(id) !== -1 && h) ufWishlistMetaSet(id, h);
        });
        e = t(".wishlist-tile-container");
        a = e.length;
        e.each(function () {
            var id = String(t(this).attr("data-product-id") || "");
            if (l.indexOf(id) === -1) {
                t(this).remove();
                a--;
            }
        });
        var done = function (finalA) {
            if (window.ufWishlistPruneToVisibleTiles) {
                l = window.ufWishlistPruneToVisibleTiles();
            } else {
                var grid = document.querySelector(".wishlist-grid");
                if (grid) {
                    var vis = [];
                    grid.querySelectorAll(".wishlist-tile-container[data-product-id]").forEach(function (el) {
                        var id = String(el.getAttribute("data-product-id") || "").trim();
                        if (id) vis.push(id);
                    });
                    ufSaveWishlistIds(vis);
                }
            }
            t(".wishlist-btn").each(function () {
                var pid = String(t(this).attr("data-product-id") || "");
                l.indexOf(pid) > -1 &&
                    (t(this).addClass("is-active"),
                    t(this).attr("data-original-title", "Remove from Wishlist"),
                    t(this).find("span").first().html(
                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.15 16.927"><path d="M13.67 0a4.85 4.85 0 0 0-4.1 2.23A4.86 4.86 0 0 0 5.47 0 5.53 5.53 0 0 0 0 5.67c0 2.42 1.2 4.8 3.53 7.1a24.9 24.9 0 0 0 5.82 4.1.5.5 0 0 0 .46 0 24.94 24.94 0 0 0 5.82-4.1c2.34-2.3 3.53-4.68 3.53-7.1A5.53 5.53 0 0 0 13.67 0z"/></svg>'
                    ));
            });
            t(".wishlist-loader").fadeOut(2e3, function () {
                t(".wishlist-grid").addClass("is_visible"),
                    t(".wishlist-hero").addClass("is_visible"),
                    0 == finalA ? t(".wishlist-grid--empty-list").addClass("is_visible") : t(".wishlist-grid--empty-list").hide(),
                    t(".wishlist-grid").fadeIn("slow");
            });
            window.ufNotifyWishlistUpdated && window.ufNotifyWishlistUpdated();
        };
        ufFetchMissingWishlistTiles(l, a).then(done);
    };
    var n = function () {
        t(document)
            .off("mouseleave.wishlistUf", ".wishlist-btn")
            .on("mouseleave.wishlistUf", ".wishlist-btn", function (i) {
                i.stopPropagation(),
                    t(this).next(".tooltip").remove(),
                    setTimeout(() => {
                        t("#fake_input").blur();
                    }, 10);
            });
        t(document)
            .off("click.wishlistUf", ".wishlist-btn")
            .on("click.wishlistUf", ".wishlist-btn", function (i) {
                var s,
                    el = this;
                i.preventDefault(),
                    (function (i) {
                        var sid = String(t(i).attr("data-product-id") || ""),
                            handle = String(t(i).attr("data-product-handle") || "").trim();
                        if (t(i).hasClass("is-active")) {
                            var e = l.indexOf(sid);
                            e > -1 && (l.splice(e, 1), ufSaveWishlistIds(l));
                        } else (l.push(sid), handle && ufWishlistMetaSet(sid, handle), ufSaveWishlistIds(l));
                    })(el),
                    t((s = el)).toggleClass("is-active"),
                    window.ufNotifyWishlistUpdated && window.ufNotifyWishlistUpdated(),
                    t(s).hasClass("is-active")
                        ? (t(s).attr("data-original-title", "Remove from Wishlist"),
                          t(s).next(".tooltip").length && t(s).next(".tooltip").find(".tooltip-inner").text("Added to Wishlist"))
                        : (t(s).attr("data-original-title", "Add to Wishlist"),
                          t(s).next(".tooltip").length && t(s).next(".tooltip").find(".tooltip-inner").text("Removed from Wishlist")),
                    h(s);
            });
    };
    var h = function (i) {
            t(".wishlist_mobile").removeClass("wishlist_mobile--show"),
                t(window).width() < 1025 && t(i).hasClass("is-active")
                    ? t(".wishlist_mobile .wishlist_text").text("Added to wishlist")
                    : t(".wishlist_mobile .wishlist_text").text("Removed from wishlist"),
                setTimeout(function () {
                    t(".wishlist_mobile").addClass("wishlist_mobile--show");
                }, 50);
        };
    i.init = function () {
        (l = window.ufWishlistReadIds ? window.ufWishlistReadIds() : ufReadWishlistIds()),
            n(),
            t(".wishlist-btn").each(function () {
                var pid = String(t(this).attr("data-product-id") || "");
                l.indexOf(pid) > -1 &&
                    (t(this).addClass("is-active"),
                    t(this).attr("data-original-title", "Remove from Wishlist"),
                    t(this).find("span").first().html(
                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.15 16.927"><path d="M13.67 0a4.85 4.85 0 0 0-4.1 2.23A4.86 4.86 0 0 0 5.47 0 5.53 5.53 0 0 0 0 5.67c0 2.42 1.2 4.8 3.53 7.1a24.9 24.9 0 0 0 5.82 4.1.5.5 0 0 0 .46 0 24.94 24.94 0 0 0 5.82-4.1c2.34-2.3 3.53-4.68 3.53-7.1A5.53 5.53 0 0 0 13.67 0z"/></svg>'
                    ));
            }),
            o(),
            window.ufSyncWishlistNavIndicator && window.ufSyncWishlistNavIndicator();
    };
    t(document).on("click", ".action--wishlist.wishlist-btn.is-active", function () {
        var pid = String(t(this).attr("data-product-id") || "");
        t('.wishlist-tile-container[data-product-id="' + pid.replace(/"/g, '\\"') + '"]').remove();
    });
}(window.Wishlist = window.Wishlist || {}, jQuery);
